import { FaBriefcase, FaListOl, FaHourglassHalf } from "react-icons/fa";
import Toggle from "modules/swiftboard/components/ui/Toggle";
import { SectionShell, inputCls, WORKING_DAYS, ToggleRow } from "./settings-shared";

export default function WorkPreferencesSection({ formData, onChange }) {
  const toggleDay = (day) => {
    const days = formData.working_days.includes(day)
      ? formData.working_days.filter((d) => d !== day)
      : [...formData.working_days, day];
    onChange("working_days", days);
  };

  return (
    <SectionShell id="work-preferences" icon={FaBriefcase} title="Work Preferences" subtitle="Defaults for your project workspace">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-1">
        <div>
          <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
            <FaListOl size={11} className="text-text_muted shrink-0" />
            Projects per page
          </label>
          <input
            type="number"
            min={1}
            value={formData.projects_per_page}
            onChange={(e) => onChange("projects_per_page", e.target.value)}
            className={inputCls}
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-text_secondary mb-1.5 flex items-center gap-1.5">
              <FaHourglassHalf size={11} className="text-text_muted shrink-0" />
              Work starts
            </label>
            <input
              type="time"
              value={formData.working_hours_start}
              onChange={(e) => onChange("working_hours_start", e.target.value)}
              className={inputCls}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-text_secondary mb-1.5">Work ends</label>
            <input
              type="time"
              value={formData.working_hours_end}
              onChange={(e) => onChange("working_hours_end", e.target.value)}
              className={inputCls}
            />
          </div>
        </div>
      </div>

      <div className="mt-4">
        <label className="block text-xs font-medium text-text_secondary mb-2">Working days</label>
        <div className="flex flex-wrap gap-2">
          {WORKING_DAYS.map((day) => {
            const active = formData.working_days.includes(day);
            return (
              <button
                key={day}
                type="button"
                onClick={() => toggleDay(day)}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-colors ${
                  active
                    ? "border-primary bg-primary/[0.08] text-primary"
                    : "border-border text-text_secondary hover:bg-surface_alt"
                }`}
              >
                {day}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-border/60">
        <ToggleRow label="Show completed projects" description="Include completed projects in default project lists">
          <Toggle checked={!!formData.show_completed_projects} onChange={(v) => onChange("show_completed_projects", v)} />
        </ToggleRow>
      </div>
    </SectionShell>
  );
}
